import { motion } from "framer-motion";
import { EASE } from "./Hero";

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function ChapterTag({ num, title, testid }) {
    return (
        <Reveal>
            <div data-testid={testid} className="flex items-center gap-4">
                <span className="font-serifed italic text-2xl md:text-3xl text-gold">{num}</span>
                <span className="font-mono text-[11px] md:text-xs uppercase tracking-[0.3em] text-slate-400">
                    {title}
                </span>
                <span className="h-px flex-1 bg-white/10" />
            </div>
        </Reveal>
    );
}
